import { Button, Grid } from '@mui/material'
import React, { useState } from 'react'
import '@smastrom/react-rating/style.css'
import CustomDrawer from './mobileDropdownDrawer';
import { primaryColor } from '../../../../../utils/colors';



const DropdownTemplate = (props: any) => {
    const { thread, data, chatbotTheme, setDrawerProps, drawerProps } = props
    const [flagSubmit, setFlagSubmit] = React.useState(false)
    const [searchValue, setSearchValue] = useState("")


    function isDisable() {
        if (thread?.seq || flagSubmit) {
            return true
        } else {
            return false
        }
    }
    const handleSetMobileDrawer = () => {
        setDrawerProps({
            ...drawerProps,
            openDrawer: true,
            dropdown_options: data.message_fields.dropdown_options,
            option_key_name: "name",
            flag_multiple: data.message_fields.flag_multiple,
            image_url: null,
            dropdown_name: data.message_fields.list_name
        })
    }

    return (
        <>
            <Grid item className={'cr-main-item'}>
                <Grid container>
                    <Grid item xs={12}
                    >
                        <Grid container>
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Grid container sx={{ justifyContent: 'space-between', alignItems: 'start', marginTop: "10px" }}>
                                    {/* <Grid item xs={12}> */}
                                    {data?.message_fields?.list_name && 
                                        <Button
                                            sx={{
                                                textTransform: "unset",
                                                backgroundColor: chatbotTheme?.chatbot_send_message_icon_color ? chatbotTheme?.chatbot_send_message_icon_color : primaryColor,
                                                color: chatbotTheme?.chatbot_header_color ? `${chatbotTheme?.chatbot_header_color} !important` : "",
                                                fontWeight: "500 !important", borderRadius: "5px !important", padding: "5px 10px !important",
                                                minWidth: "unset !important",
                                                '&:hover': { color: chatbotTheme?.chatbot_header_color ? `${chatbotTheme?.chatbot_header_color} !important` : "", backgroundColor: chatbotTheme?.chatbot_send_message_icon_color ? `${chatbotTheme.chatbot_send_message_icon_color} !important` : "" }
                                            }}
                                            variant={'outlined'}
                                            disabled={isDisable()}
                                            size='small'
                                            onClick={(e) => {
                                                handleSetMobileDrawer()
                                            }}
                                        >
                                            {data.message_fields.list_name}
                                        </Button>
                                    }
                                    {/* </Grid> */}
                                </Grid>
                            </Grid>

                            <CustomDrawer
                                chatbotTheme={chatbotTheme}
                                drawerOpen={drawerProps.openDrawer}
                                handleDrawerClose={() => {
                                    setDrawerProps({ ...drawerProps, openDrawer: false });
                                    setTimeout(() => {
                                        document.getElementById('paraphraseInput')?.blur();
                                        document.getElementById('toneOfVoice')?.blur()
                                        document.getElementById('languageList')?.blur()
                                        document.getElementById('noOfOutput')?.blur();
                                        document.getElementById('length')?.blur()
                                    }, 200)
                                }}
                                dropdown_options={drawerProps.dropdown_options}
                                option_key_name={drawerProps.option_key_name}
                                flag_multiple={drawerProps.flag_multiple}
                                image_url={drawerProps.image_url}
                                dropdown_name={drawerProps.dropdown_name}
                                handleRecursion={props.handleRecursion}
                                setFlagSubmit={setFlagSubmit}
                                flagSubmit={flagSubmit}
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default DropdownTemplate